const information = {
  path: 'information/:merchantId',
  component: resolve => require(['../../../../../pages/admin/reviewed/information'], resolve)
}

export default information
